import React from 'react';
import PaymentOrdersOverview from './PaymentOrdersOverview';
import { PAYMENT_ENDPOINTS } from './constants';

const PaymentsList = () => {
  return (
    <PaymentOrdersOverview
      paymentEndpoint={PAYMENT_ENDPOINTS.LIST}
    />
  );
};

export default PaymentsList;